<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div class="content" v-show="!state.loading">
            <div class="rctr v-flex">
                <div class="ctr">
                    <p>Date Range</p>
                    <DateRange  v-model="dateRange" iclass="form-control" ref="dateRangeRef"/>
                </div>
                <div class="ctr" v-if="false">
                    <p>Account</p>
                    <select>
                        <option value="cash_in_out">Cash in/out</option>
                        <option value="account_wise">Account-wise Balances</option>
                    </select>
                </div>
            </div>
            <DataTable :tableData="tableData" @view="viewTransaction" @edit="edit"/>
            <div class="v-flex justify-content-end">
                <div class="rsumry" v-if="acct_type=='full'">
                    <div v-for="(s, i) in summary" :key="i">
                        <div class="smry">
                            <b>{{ s.account_type }} Account: </b>
                        </div>
                        <span>Debits : <b style="color:red">{{ s.debits }}</b></span>
                        <span>Credits : <b style="color:green">{{ s.credits }}</b></span>
                        <span>Balance : <b>{{ s.balance }}</b></span>
                    </div>
                </div>
                <div class="rsumry" v-else>
                    <div>
                        <div class="smry"><b>Total Debits: </b>{{ summary.total_cash_out }}</div>
                        <div class="smry"><b>Total Credits: </b>{{ summary.total_cash_in }}</div>
                        <div class="smry"><b>Net Flow: </b>{{ summary.net_flow }}</div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
        :fields="newFields" @submit="addTransaction"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <div v-if="!state.modalLoading">
            <FormView :columns="1"
                :fields="viewFields" 
                :loading="state.modalLoading" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">

        <div v-if="!state.modalLoading">
            <DynamicForm :columns="1" @submit="editTransaction"
                :fields="editFields" 
                :submitting="state.submitting" 
                :errors="state.errors"
                :success="state.success"
            />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 
    
</template>
<script>
import icons from '@/assets/js/icons.js';
import { reactive, ref, onMounted, watch, computed} from 'vue';
import { useStore } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import FormView from '@/components/FormView.vue';
import DateRange from '@/components/DateRange.vue';
import { useRouter, useRoute } from 'vue-router';
export default {
    name: 'TransactionsView',
    components:{PageHeader, DataTable,DynamicForm,ModalView,FormView,DateRange},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const dateRangeRef=ref(null);
        const route = useRoute();
        const router = useRouter();
        const viewFields=ref([])
        const dateRange = ref({ start: null, end: null });
        const accounts=ref([]);
        const summary=ref([]);
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true,editTaskModal:false,gettingTask:false,historyModal:false,historyLoading:true
        });
        const svgIcons = ref(icons);
        const page=ref({title:"Transaction Report", btn:"",
            desc:"Manage all transaction in one place"})
        
        var action_label=[icons.view],
        action=["view"]

        watch(dateRange, (newVal) => {
            router.push({ name: 'transactionreport', query: { start: newVal.start, end: newVal.end } });
        });

        watch(
            () => route.fullPath,
            () => {
                getPage();
            }
        );

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Date" },
                { label: "Description" },
                { label: "Account" },
                { label: "Type" },
                { label: "Amount" },
            ],
            options:{
                label:"Actions",
                action_label:action_label,
                action:action,
            },
            total:0
        });

        if(system.value.acct_type=="simple"){
            tableData.value.columns.splice(2, 1);
        }

        function getPage(){
            state.loading=true;
            var data={startTransactionReport:""},
            q=route.query;
            if(q.start){
                data.start=q.start;
                data.end=q.end
            }
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                    state.loading=false
                    if(q.start){
                        dateRangeRef.value.setDefaultRange(q.start,q.end);
                    }
                    if(res.status){
                        var d=res.msg;
                        setTable(d.transactions);
                        state.success=true;
                        summary.value=d.summary
                    }else{
                        alert(res.msg);
                    }
                }
            })
        }

        onMounted(() => {
            getPage();
        });

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
                var e=res.msg[key],er="";
                Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
                })
                errors.push(er);
            });
            state.errors=errors;
        }

        function viewTransaction(i){
            state.modalLoading=true
            state.ViewModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{getTransaction:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        viewFields.value.length=0;
                        var d=res.msg;
                        viewFields.value.push(
                            { name: "Transaction Details", number: "1",data: 
                                [{name: 'date', label: 'Transaction Date',
                                    value: d.date},
                                {name: 'desc', label: 'Description',
                                value: d.description },
                                {name: 'account', label: 'Account',
                                    value: d.acct_name},
                                {name: 'type', label: 'Transaction Type',
                                    value: d.type},
                                {name: 'amount', label: 'Amount',
                                value: d.amount },
                                {name: 'ref', label: 'Reference No.',
                                    value: d.ref_num  },
                                {name: 'note', label: 'Note',
                                    value: d.note  },
                                {name: 'add', label: 'Added By',
                                    value: d.added_by  },]
                            }
                        );
                        if(system.value.acct_type=="simple"){
                            viewFields.value[0].data.splice(2, 1);
                        }
                    }else{
                        setErrors(res)
                    }
                }
            })
        }
        

        return{state, icons:svgIcons,tableData,page,accounts,dateRange,
            viewTransaction,viewFields, acct_type:system.value.acct_type,
            dateRangeRef,summary}
    }
}
</script>

<style scoped>
</style>